var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoWsp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.89 12.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ecb3a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico wsp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.95,0A5.95,5.95,0,0,0,.83,9L.08,12l3-.86A5.95,5.95,0,1,0,5.95,0M6,10.91A4.91,4.91,0,0,1,3.22,10l-1.7.49L2,8.78A4.94,4.94,0,1,1,6,10.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.44,5.48l.21-.24c.12-.13.29-.26.3-.46a1.36,1.36,0,0,0-.12-.54L4.7,3.92a2.17,2.17,0,0,0-.28-.59.53.53,0,0,0-.6-.09A1.45,1.45,0,0,0,3,4.91,5.28,5.28,0,0,0,7.2,8.73s1.26.18,1.59-.58a1.35,1.35,0,0,0,.11-.58.48.48,0,0,0-.28-.37c-.18-.11-.35-.21-.56-.31a.9.9,0,0,0-.6-.16A.89.89,0,0,0,7.1,7l-.41.43a4.1,4.1,0,0,1-2.24-2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWsp);
export default __webpack_public_path__ + "static/media/ico-wsp.ffd62968c29769bc0f5539a0108163b8.svg";
export { ForwardRef as ReactComponent };